// flow weak

import React, {
    PureComponent,Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils';
  import TimeField from 'react-simple-timefield';
  import { Spinner } from 'react-activity';
  import ReactTable from "react-table";

  
  class ViewFixtureSession extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue:props.props.statsTable.revenue_per_month.requested_venue_id,
        details: {
            venue: '',
        },
        message:'',
        venue_list: [],
        incomplete_sessions:[],
        loading: false,
        viewOption:false,
        selected_session:'',
        selected_venue:'',
        headers: ["Day","Date","Session Time","Venue","Type","Completeness"]
      };
      this.postTicketRaising = this.postTicketRaising.bind(this);

    }
  
    componentDidMount() {
        this.getfixtureSessions();
    }

    locationChanged() {
      this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
        this.getfixtureSessions()
      })
    }

    getfixtureSessions(){
      const url = `${getLocationOrigin()}/fixture/get_fixtureSession_for_cm/?venue_id=${this.state.venue}`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {this.setState({ incomplete_sessions: data.incomplete_sessions})
        })
         .catch((error) => {
          console.log(error);
          alert(error.message);      
      });
    }
    getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    }

    

    
    toViewDetails(session_id){
      console.log(session_id)
        this.setState({viewOption:true,selected_session:session_id})
    }
    


    handleOpen = () => {
        this.setState({dialog_open_cust:true,dialog_open_failed_list:true});
    };

    
    
    handleClose = () => {
    this.setState({dialog_open_cust:false,viewOption:false, dialog_open_court_list:false,dialog_open_failed_list:false,deleteOption:false});
    };



    postTicketRaising(session){
      console.log(session.id)
            const url = `${getLocationOrigin()}/fixture/raise_ticket_for_coach/`;
            console.log(session)
            const options = {...defaultOptions};
            options['method'] = 'post'
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'session': session,

                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                alert(response.message);
                window.location.reload();
                
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });

    }



    

    
  
    render() {
      console.log('render')
      console.log(this.state)

      if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
        this.locationChanged()
      }

      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Delete"
          primary={true}
          onClick={this.postDeleteCourtPrice}
        />,
      ];

      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleClose}
        />
      ];
      const columns = [{  
       Header: 'Venue',  
       accessor: 'venue'  
       },{  
       Header: 'Day',  
       accessor: 'day',
       Cell: cellInfo  => (<span>{days.map((day,index)=>{return (day.id == cellInfo.original.day && <div>{day.name}</div>) })}</span>),
       },{  
       Header: 'Date',  
       accessor: 'date'  
       },{  
       Header: 'Type',  
       accessor: 'game_type',
       },{  
       Header: 'Time',  
       accessor: 'start_time',
       Cell: cellInfo  => (<span>{cellInfo.original.start_time} - {cellInfo.original.end_time}</span>),
       minWidth: 100
       },
       
       {
        Header: 'Completness',
        accessor: 'completness_percentage',
        Cell: cellInfo  => (<span><button className='button1' onClick={(row)=>{this.toViewDetails(cellInfo.original.id)}}>{cellInfo.original.completness_percentage + "%"}</button></span>)
        
        },
        {
        Header: 'Ticket',
        accessor: 'row',
        Cell: cellInfo  => (<span><button className='button1' onClick={(row)=>{this.postTicketRaising(cellInfo.original)}}>Raise Ticket</button></span>)
        }
       ];

      var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]
      var TYPES = [{"name":"Court Rental","id":0},{"name":"Equipment Rental","id":1},{"name":"F&B Rental","id":2},{"name":"Service Rental","id":3}]
      
      return(

        <div style={styles.container}>
           <ReactTable  
            data={this.state.incomplete_sessions}  
            className="-striped -highlight"
            columns={columns}  
            defaultPageSize = {100}  
            pageSizeOptions = {[100,200,500]} 
            getTrProps={this.getTrProps} 
            filterable={true}
            showPagination={this.state.incomplete_sessions.length > 100}
            showPaginationTop = {this.state.incomplete_sessions.length > 100}
            style = {{background:'#9370DB'}}
            defaultFilterMethod = {(filter, row, column) => {
              const id = filter.pivotId || filter.id
              return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
            }}
            > 
            {
              //To show the record count on top  
              (state, makeTable, instance) => {

                let recordsInfoText = "";

                const { filtered, pageRows, pageSize, sortedData, page } = state;

                if (sortedData && sortedData.length > 0) {
                  let isFiltered = filtered.length > 0;

                  let totalRecords = sortedData.length;

                  let recordsCountFrom = page * pageSize + 1;

                  let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                  if (isFiltered){
                    recordsInfoText = `${totalRecords} filtered records`;
                  }
                  else {
                    recordsInfoText = `${totalRecords} records`;
                  }
                } else {
                    recordsInfoText = "No records";
                  }
                return (
                  <div className="main-grid">
                    <div className="above-table text-right">
                      <div className="col-sm-12 records-info">
                        <span className="">{recordsInfoText}</span>
                      </div>
                    </div>
                    {makeTable()}
                    
                  </div>

                );
              }
            }
         </ReactTable >
            

              {this.state.incomplete_sessions.map((session,index) =>  
                    <div  style={{'marginTop':"2px",'fontSize':"14px",'textAlign':"center",'display':"flex",'flexDirection':"row",'border-style':"outset",'backgroundColor':"white"}}>
                            <div style={{'marginLeft':"1px",'width':"12%",'padding':"2%"}}>
                                <input type="button" className="button1"  value={session.completness_percentage + "%"} onClick={()=>{this.toViewDetails(session.id)}} />
                                {this.state.viewOption  && this.state.selected_session == session.id &&
                                <Dialog
                                  actions={okaction}
                                  modal={false}
                                  open={this.state.viewOption}
                                  onClick={this.handleClose}
                                  autoDetectWindowHeight={true}
                                  autoScrollBodyContent={true}
                                  scroll={scroll}
                                  dividers={scroll === 'paper'}
                                >
                                    <div style={styles.main_header} className="col-md-12">
                                        DETAILS
                                    </div>
                                    <div className="col-md-12" style={{'display':"flex",'flexDirection':"column",'fontSize':"20px"}}>
                                              <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'border-style':"outset",'fontSize':"20px",}}>
                                                  <div className="col-md-6" style={{'color':'Blue'}}>
                                                    Buddy Allocated
                                                  </div>
                                                  {
                                                    session.buddy_detail.map((fsbuddy,fsb) =>
                                                    <div className="col-md-6"  style={{'textAlign':'center'}}>
                                                      {fsbuddy.name}
                                                    
                                                    </div>
                                                    )
                                                  }
                                              </div>
                                              <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'border-style':"outset",'fontSize':"20px"}}>
                                                  <div className="col-md-6" style={{'color':'Blue'}}>
                                                    Buddy Attendance
                                                  </div>
                                                  {
                                                    session.buddy_detail.map((fsbuddy,fsb) =>
                                                    <div className="col-md-6" >
                                                    
                                                      {fsbuddy.attendance_done ?
                                                        <div style={{'textAlign':'center'}}>
                                                        YES
                                                        </div> :
                                                        <div style={{'textAlign':'center','backgroundColor':'red'}}>
                                                        NO
                                                        </div>
                                                      }
                                                    
                                                    </div>
                                                    )
                                                  }
                                              </div>
                                              <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'border-style':"outset",'fontSize':"20px"}}>
                                                  <div className="col-md-6" style={{'color':'Blue'}}>
                                                    Player Attendance
                                                  </div>
                                                  {
                                                    session.buddy_detail.map((fsbuddy,fsb) =>
                                                    <div className="col-md-6" >
                                                    
                                                      {session.player_attendence ?
                                                        <div style={{'textAlign':'center'}}>
                                                        YES
                                                        </div> :
                                                        <div style={{'textAlign':'center','backgroundColor':'red'}}>
                                                        NO
                                                        </div>
                                                      }
                                                    
                                                    </div>
                                                    )
                                                  }
                                              </div>
                                              <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'border-style':"outset",'fontSize':"20px"}}>
                                                  <div className="col-md-6" style={{'color':'Blue'}}>
                                                    Skill Rating
                                                  </div>
                                                  {
                                                    session.buddy_detail.map((fsbuddy,fsb) =>
                                                    <div className="col-md-6" >
                                                    
                                                      {session.Skill_rating ?
                                                        <div style={{'textAlign':'center'}}>
                                                        YES
                                                        </div> :
                                                        <div style={{'textAlign':'center','backgroundColor':'red'}}>
                                                        NO
                                                        </div>
                                                      }
                                                    
                                                    </div>
                                                    )
                                                  }
                                              </div>
                                              <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'border-style':"outset",'fontSize':"20px"}}>
                                                  <div className="col-md-6" style={{'color':'Blue'}}>
                                                    Stats Done
                                                  </div>
                                                  {
                                                    session.buddy_detail.map((fsbuddy,fsb) =>
                                                    <div className="col-md-6" >
                                                    
                                                      {session.game_stats_done ?
                                                        <div style={{'textAlign':'center'}}>
                                                        YES
                                                        </div> :
                                                        <div style={{'textAlign':'center','backgroundColor':'red'}}>
                                                        NO
                                                        </div>
                                                      }
                                                    
                                                    </div>
                                                    )
                                                  }
                                              </div>
                                    </div>
                                </Dialog>
                                }
                            </div>
                            
                </div>
                )}
        
      </div>
    );
    }
  }
  export default ViewFixtureSession;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureSession/index.js